import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';
const PageContainer: React.FC<{
  children: React.ReactNode;
  props?: BoxProps;
}> = ({ children, props }) => {
  return (
    <Box maxW="6xl" mx="auto" width="100%" {...props}>
      {children}
    </Box>
  );
};

export default PageContainer;
